import React, { Component } from "react";
import { observer } from "mobx-react";
import home from "../../store/index.js";
import fisttitle from "../../static/images/fisttitle.png";
import roof from "../../static/images/roof.png";
import writeSelect from "../../static/images/writeSelect.png";
import redSelect from "../../static/images/redSelect.png";

import "./index.css";
@observer
class Home extends Component {
  constructor() {
    super();
    this.state = {
      ageList: ["00", "95", "90", "85", "80", "其他"],
      age: "90",
      workYearsList: [
        "0-3年",
        "3-5年",
        "5-10年",
        "10-15年",
        "15-20年",
        "20年+",
      ],
      workYears: "0-3年",
    };
  }
  ChangeAge(age) {
    this.setState({ age });
  }
  ChangeWork(workYears) {
    this.setState({ workYears });
  }
  register() {
    home.register({ workYears: this.state.workYears, age: this.state.age });
  }
  render() {
    return (
      <div className="SeconedEnter">
        <div className="SeconedEnter_t">
          <div className="SeconedEnter_t_tp">
            <i className="SeconedEnter_t_tp_t">
              <img src={fisttitle} alt="" />
            </i>
            <i className="SeconedEnter_t_tp_b">
              <img src={roof} alt="" />
            </i>
          </div>
          <div className="SeconedEnter_t_bt">
            <div className="SeconedEnter_t_bt_center">
              <div className="SeconedEnter_t_bt_tp">
                <span>来了？欢迎你！</span>
              </div>
              {/* 年龄选择 */}
              <div className="SeconedEnter_t_bt_bt">
                <p>我是</p>
                <div className="SeconedEnter_t_bt_bt_age">
                  {this.state.ageList.map((item, index) => (
                    <div
                      key={item}
                      onClick={() => {
                        this.ChangeAge(item);
                      }}
                    >
                      {item}
                      {item !== "其他" ? "后" : ""}{" "}
                      {this.state.age === item ? (
                        <i>
                          <img src={writeSelect} alt="" />
                        </i>
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className="SeconedEnter_t_bt_bt_cent"></div>
              <div className="SeconedEnter_t_bt_bt_workage">
                <p>我的职场工作年限</p>
                <div className="SeconedEnter_t_bt_bt_workage_ct">
                  {this.state.workYearsList.map((item, index) => (
                    <div
                      key={item}
                      onClick={() => {
                        this.ChangeWork(item);
                      }}
                    >
                      {item}
                      {this.state.workYears === item ? (
                        <i>
                          <img src={redSelect} alt="" />
                        </i>
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="SeconedEnter_c">
            在进入铺子之前，让我们先认识认识你吧~
          </div>
        </div>

        <div
          className="SeconedEnter_b"
          onClick={() => {
            this.register();
          }}
        >
          进入职场解忧
        </div>
      </div>
    );
  }
}
export default Home;
